// test1072
(1072 && 0);
